export const downloadBlogBackup = (local, remote = null) => {
  const payload = JSON.stringify({ schemaVersion: 1, exportedAt: new Date().toISOString(), local, remote }, null, 2)
  const url = URL.createObjectURL(new Blob([payload], { type: 'application/json' }))
  const link = document.createElement('a')
  link.href = url
  link.download = `blog-${local.id}-backup-${Date.now()}.json`
  document.body.appendChild(link)
  link.click()
  link.remove()
  setTimeout(() => URL.revokeObjectURL(url), 60000)
}
